import { createSlice } from "@reduxjs/toolkit";

const logininfo=createSlice({
    name:"logininfo",
    initialState:{usern:'',expires:0,role:'',menu:false},
    reducers:{
        setUserinfo:(state,action)=>{
            state.usern=action.payload.usern
            state.expires=action.payload.expires
            state.role=action.payload.role
            state.menu=action.payload.menu
        },
        setMenuClose:(state,action)=>{
            state.menu=action.payload.menu
        }
    }
});

export const {setUserinfo,setMenuClose}=logininfo.actions;
export default logininfo.reducer;